import React, { useState, useEffect, useCallback, useRef } from "react";
import { Row, Col, Form, Select , Icon, Tooltip} from "antd";
import ReusableInput from "./ReusableInput";
import Select_v2 from "./Select_v2";
import Checkbox_v2 from "./Checkbox_v2";
import SectionCard from "./SectionCard";
import Button_v2 from "./Button_v2";
import WarehouseIcon from "../../../assets/images/WarehouseColor.svg";

import { RadioActiveIcon } from "../../components/orders/OrderTypeIcons";
import { alertMessage, ellipseText } from "../../common/Common";
import PropTypes from "prop-types";
import PhoneIcon from "../../../assets/images/PhoneIcon.svg";
import MailIcon from "../../../assets/images/EmailIcon.svg";
import LocationIcon from "../../../assets/images/locationImageIcon.svg";
import ClockIcon from "../../../assets/images/clockIcon.svg";
import { fetchAccountDetails } from "../../api/Account";
import { renderAlertMessage } from "../../helpers/common";
import InfoIcon, { NoteIcon } from "../../common/CustomIcon";
import noImg from "../../../assets/images/noImg.png";
import InfoTooltip from "../../stories/components/InfoTooltip";
import { use } from "react";
import { getFomattedAccountTime } from "../../helpers/date_functions";
import { deferFocus } from "../../helpers/focusUtils";
// v2 Account block design swap — Friday rollout (feature/v2-order-redesign).
// Pure visual replacement: same `accounts` source, same `updateOrderDetails`
// callback, same credit-exceeded warning data. The legacy Select_v2 +
// ContactCard pair stay in the file as dead code (commented below) for quick
// rollback during stabilization.
import AccountBlockV2 from "./account_v2/AccountBlockV2";
import I18n from '../../common/I18n';

const OrderdetailsComponent = React.memo((props) => {
  const {
    warehouses,
    accounts,
    configData,
    updateOrderDetails,
    referencesData = [],
    vehicleTypes = [],
    getDataRef,
    getFieldDecorator,
    updatedAccountId,
    setFieldsValue,
    order_label_code,
    whStorage,
    showActions = false,
    details = {},
    handleValidate = () => {},
    onCancel = () => {},
    actionType = 'create',
    creditsExceededAccnts,
    // Phase 4.3 Mode A: when present, account select/clear route through the
    // screen's confirm-reset handlers instead of the default path.
    modeAAccountChange,
    modeAClearAccount,
    currentPreplan,
    setOutofPreplan,
    currentRoute,
    orgSettings,
    accInputRef,
    // Phase 4.1 Mode A: when true, the account select is disabled because the
    // account was prefilled from ServiceLevelOrderModal's route state. Defaults
    // to false so Mode B / normal create and edit screens are unaffected.
    lockAccount = false
  } = props;
  const [formValues, setFormValues] = useState({
    account_id:  details?.account_id || "",
    // hawb: "",
    // mawb: "",
    // reference_1: "",
    // reference_1_type: "",
    // reference_2: "",
    // reference_2_type: "",
    // references: [],
    // special: false,
    // is_hazardous: false,
    // priority: false,
    // vehicle_type: "",
    // wh_storage: ['LH', 'RD', 'RT', 'OBT'].includes(order_label_code) || false,
    //...details,
  });
  const [accountDetails, setAccountDetails] = useState({});
  // True while the enriched account_details (email/phone/contact) are being
  // fetched for the selected account — drives the AccountBlockV2 loading state
  // so the card doesn't flash empty chips before the data lands.
  const [accountDetailsLoading, setAccountDetailsLoading] = useState(false);
  const [hoveredField, setHoveredField] = useState(null);

  useEffect(() => {
    if (['view','update'].includes(actionType)) {
      setFieldsValue({
        account_id: details.account_id,
        warehouse_id: details.warehouse_id
      });
    }
  }, []);

  useEffect(() => {
    if (['view','update'].includes(actionType)) {
      //alertMessage(details)
      // setFieldsValue({
      //   ...details
      // });
      setFormValues({
        ...formValues,
        ...(_.pick(details, ["account_id"]))
      })
    }
    if(['create'].includes(actionType)) {
      setFormValues({
        ...formValues,
        type_of_order: details.type_of_order,
        label_code: details.label_code,
      })
    }
  }, [details]);

  useEffect(() => {
    if (updatedAccountId !== formValues.account_id) {
      setFormValues({
        ...formValues,
        account_id: updatedAccountId,
      });
      setFieldsValue({
        account_id: updatedAccountId,
      });
    }
  }, [updatedAccountId]);

  // Generation counter: a stale fetch (e.g. user rapidly switches accounts
  // before the previous request resolves) must not overwrite the latest
  // accountDetails. Each effect run bumps the counter and the callback
  // checks it before committing the result.
  const accountFetchGenRef = useRef(0);
  useEffect(() => {
    if (updatedAccountId) {
      const gen = ++accountFetchGenRef.current;
      setAccountDetailsLoading(true);
      fetchAccountDetails(updatedAccountId).then((result) => {
        if (gen !== accountFetchGenRef.current) return;
        if (result.success) {
          const accountDetails = result.account_details || [];
          setAccountDetails(accountDetails);
        } else {
          renderAlertMessage(result.errors);
        }
      }).finally(() => {
        // Guard on gen so a stale request doesn't clear the spinner of a newer one.
        if (gen === accountFetchGenRef.current) setAccountDetailsLoading(false);
      });
    } else {
      accountFetchGenRef.current += 1;
      setAccountDetails({});
      setAccountDetailsLoading(false);
    }
  }, [updatedAccountId]);
  useEffect(() => {
    if (getDataRef) {
      getDataRef.current = () => formValues;
    }
  }, [formValues, getDataRef]);

  // useEffect(() => {
  //   const whStorageRequiredCodes = ['LH', 'RD', 'RT', 'OBT'];
  //   if (whStorageRequiredCodes.includes(order_label_code) || ['R', 'D'].includes(order_label_code)) {
  //     setFormValues((prevState) => ({
  //       ...prevState,
  //       wh_storage: whStorageRequiredCodes.includes(order_label_code) || (!['R', 'D'].includes(order_label_code))
  //     }));
  //   }
  // }, [order_label_code]);

  // useEffect(() => {
  //   if (formValues.wh_storage !== whStorage) {
  //     setFormValues((prevState) => ({
  //       ...prevState,
  //       wh_storage: whStorage,
  //     }));
  //   }
  // }, [whStorage]);

  // const handleChange = (e) => {
  //   const { name, value, checked, type } = e.target;
  //   setFormValues((prevState) => ({
  //     ...prevState,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  // const checkboxHandleChange = (element, value) => {
  //   setFormValues((prevState) => ({
  //     ...prevState,
  //     [element]: value,
  //   }));
  // };

  const handleSelectChange = (value, fieldName) => {
    setFormValues((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
    if (["account_id", "warehouse_id"].includes(fieldName)) {
      updateOrderDetails(fieldName, value);
    }
  };

  const handleWHChange = (value, fieldName) => {
     if(value && currentPreplan?.warehouse_id !== value){
       setOutofPreplan(true)
    }
     handleSelectChange(value, fieldName)
  };

  // const addonBeforeReference1 = (
  //   <Select_v2
  //     defaultValuePlaceholder={"Ref Type"}
  //     options={referencesData?.filter(
  //       (rec) => rec.order_reference_type !== formValues.reference_2_type
  //     )}
  //     value={formValues.reference_1_type}
  //     onChange={(val) => handleSelectChange(val, "reference_1_type")}
  //     valueField={"order_reference_type"}
  //     labelField={"order_reference_type"}
  //     style={{ width: "100px", lineHeight: "24px" }}
  //     placeholder="Ref Type"
  //     showSelectOption={true}
  //   />
  // );
  // const addonBeforeReference2 = (
  //   <Select_v2
  //     defaultValuePlaceholder={"Ref Type"}
  //     options={referencesData?.filter(
  //       (rec) => rec.order_reference_type !== formValues.reference_1_type
  //     )}
  //     value={formValues.reference_2_type}
  //     onChange={(val) => handleSelectChange(val, "reference_2_type")}
  //     style={{ width: "100px", lineHeight: "24px" }}
  //     valueField={"order_reference_type"}
  //     labelField={"order_reference_type"}
  //     placeholder="Ref Type"
  //     showSelectOption={true}
  //   />
  // );

  const ContactCard = () => {

    return (
      <div className="card">
        <div>
          <img
            src={accountDetails?.logo?.url ? accountDetails?.logo?.url : noImg}
            alt="ShipStuff Logo"
            className="logo"
          />
        </div>
        <div className="details">
          <div className="name-container">
            <p className="name">{accountDetails.name || "Not Availble"}</p>
            {creditsExceededAccnts.includes(accountDetails.code) && (
              <InfoIcon
                width="24px"
                height="24px"
                // color="#4CAF50"
                className="info-icon"
                //   onClick={() => handleInfoClick()}
                styling={{ cursor: "pointer" }}
              />
            )}
          </div>
          <div>
            <img src={LocationIcon} className="icon" alt="" />
            {accountDetails?.address ? (
              <span className="address-items">
                {accountDetails?.address?.address_line1}.&nbsp;
                {accountDetails?.address?.city},&nbsp;{" "}
                {accountDetails?.address?.state}{" "}
                {accountDetails?.address?.zipcode}{" "}
                {accountDetails?.address?.country}
              </span>
            ) : (
              <span className="address-items">Not Availble</span>
            )}
          </div>

          <div className="contact">
            <div>
              <img src={PhoneIcon} className="icon" alt="" />
              <span className="address-items">
                {accountDetails?.phone_number || "No Phone Number"}
              </span>
            </div>
            <div>
              <img src={ClockIcon} className="icon" alt="" />
              <span className="address-items">
                {configData?.route_delivery_start_time &&
                configData?.route_delivery_end_time
                  ? getFomattedAccountTime(configData?.route_delivery_start_time, configData?.route_delivery_end_time, orgSettings?.is_military_time)
                  : "Time Not Available"}
              </span>
            </div>
            <div>
              <img src={MailIcon} className="icon" alt="" />
              <span className="address-items">
                {accountDetails?.email || "No Email"}
              </span>
            </div>
              <div>
              <Tooltip title="Shipper Notes">
              <NoteIcon width="14px" height="14px"/>
              </Tooltip>
              <span className="address-items">
                {details?.shipper_note?.trim() ? ellipseText(details?.shipper_note, 20, true) : "No Notes"}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <SectionCard
      // Account block (AccountBlockV2) is self-carding; outside view mode this
      // SectionCard wraps only it, so render flat to avoid a card-in-a-card
      // (matches Figma — a single Account card).
      flat={actionType !== "view"}
      bodyStyle={{ marginTop: "0px" }}
      // title={"Order Details"}
      // extraActionNode={
      //   <div style={{ display: "flex", gap: "10px" }}>
      //     {!["D", "R","MS"].includes(order_label_code) && (
      //       <Checkbox_v2
      //         name="wh_storage"
      //         checkValue={formValues.wh_storage}
      //         label="Warehouse Storage"
      //         size={"large"}
      //         handleChange={(e) => checkboxHandleChange('wh_storage', e)}
      //         isDisabled={['LH', 'RD', 'RT', 'OBT'].includes(order_label_code)}
      //       />
      //     )}
      //     <Checkbox_v2
      //       name="special"
      //       checkValue={formValues.special}
      //       label="Special"
      //       size={"large"}
      //       handleChange={(e) => checkboxHandleChange("special", e)}
      //     />
      //     <Checkbox_v2
      //       name="priority"
      //       checkValue={formValues.priority}
      //       label="Priority"
      //       size={"large"}
      //       handleChange={(e) => checkboxHandleChange("priority", e)}
      //     />
      //     <Checkbox_v2
      //       name="is_hazardous"
      //       checkValue={formValues.is_hazardous}
      //       label="Hazmat"
      //       size={"large"}
      //       handleChange={(e) => checkboxHandleChange("is_hazardous", e)}
      //       style={{ marginRight: 4 }} // Reducing right margin of the checkbox
      //     />
      //     <RadioActiveIcon
      //       width="16"
      //       height="16"
      //       color1="#1D2540"
      //     />
      //   </div>
      // }
    >
      <div className="innerContainer">
        {/* <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}> */}
        <Row gutter={[15, 15]}>
          {actionType === "view" && (
            <Col span={6} className="dropdown-field table-col">
              <Form.Item
                label={I18n.t('general.warehouse')}
                className="custom-form-item required-star-right"
              >
                {getFieldDecorator("warehouse_id", {
                  rules: [
                    { required: true, message: `Please Select ${I18n.t("general.warehouse")}` },
                  ],
                })(
                  <Select_v2
                    options={warehouses}
                    labelField={"name"}
                    valueField={"id"}
                    value={formValues.warehouse_id}
                    onChange={(val) => handleWHChange(val, "warehouse_id")}
                    //   icon={<MenuOutlined />}
                    style={{ width: "100%" }}
                    placeholder="Choose an option"
                    prefixIcon={<Icon type="down" />}
                  />
                )}
              </Form.Item>
            </Col>
          )}
          {/* v2 Account block — design-only swap. AccountBlockV2 renders the
              new chip-card design and falls back to a search picker when no
              account is selected. The picker → onSelectAccount callback
              feeds the same `updateOrderDetails("account_id", id)` path the
              legacy Select_v2 used, so cascade/LoS/references handling
              downstream are unchanged. View mode passes readOnly so the
              picker is suppressed and the "Change Account" button hides. */}
          <Col
            lg={actionType === "view" ? 18 : 24}
            md={24}
            sm={24}
            className="dropdown-field table-col"
            style={{ paddingBottom: "0px" }}
          >
            {/* Hidden Form.Item keeps antd's `getFieldDecorator`-driven
                validation alive ("Please Select an Account" on submit
                without touching the new UI). The new chip picker drives the
                same `account_id` field via setFieldsValue. */}
            <Form.Item style={{ display: "none" }}>
              {getFieldDecorator("account_id", {
                rules: [{ required: true, message: "Please Select an Account" }],
              })(<input type="hidden" />)}
            </Form.Item>
            <AccountBlockV2
              accounts={accounts}
              // Auto-focus + open the account dropdown whenever the user must pick the
              // account instead of it being auto-selected: Mode A (modeAAccountChange set)
              // OR Mode B with disable_account_auto_selection on. Without the second case,
              // Mode B + that setting left the field unfocused/closed. The AccountBlockV2
              // effect still guards selectedAccountId/readOnly, so it never steals focus on
              // edit/view or once an account is chosen.
              autoFocusOnMount={Boolean(modeAAccountChange) || orgSettings?.disable_account_auto_selection === "true"}
              selectedAccountId={formValues.account_id}
              accountDetails={accountDetails}
              loadingDetails={accountDetailsLoading}
              creditsExceededAccnts={creditsExceededAccnts}
              readOnly={actionType === "view"}
              onSelectAccount={(id) => {
                // Phase 4.3 Mode A: route through the screen's confirm-reset handler.
                if (modeAAccountChange) { modeAAccountChange(id); return; }
                setFieldsValue({ account_id: id });
                handleSelectChange(id, "account_id");
                // Mode B keyboard cascade: account chosen -> focus the first leg's address
                // search, mirroring Mode A's post-service-level focus (applyServiceLevel in
                // CreateOrderScreen). Mode B has no service-level step, so the account pick
                // is the step that should hand off to the leg. Legs already render in Mode B;
                // defer a tick for any account-driven re-render. Cross Dock legs name their
                // search `cdf2_search` rather than `lav2_location_search`, so match both.
                if (actionType === "create") {
                  deferFocus(() => document.querySelector('input[name="lav2_location_search"], input[name="cdf2_search"]'), 250);
                }
              }}
              onClearAccount={() => {
                if (modeAClearAccount) { modeAClearAccount(); return; }
                setFieldsValue({ account_id: "" });
                handleSelectChange("", "account_id");
              }}
            />
          </Col>
          {/* Legacy dropdown + ContactCard layout — kept here as a comment
              for quick rollback to v2 behavior if the redesign needs to be
              reverted. DO NOT delete this block during stabilization.
            <Col lg={12} md={24} sm={24} className="dropdown-field table-col">
              <Select_v2 options={accounts} ... />
            </Col>
            {actionType !== "view" && (
              <Col lg={12} md={24} sm={24}><ContactCard /></Col>
            )}
          */}
          
          {/* <Col span={6} className="dropdown-field table-col">
              <Form.Item label="Vehicle Type" className="custom-form-item">
                <Select_v2
                  options={vehicleTypes}
                  value={formValues.vehicle_type}
                  onChange={(val) => handleSelectChange(val, "vehicle_type")}
                  style={{ width: "100%" }}
                  placeholder="Choose an option"
                  labelField={"name"}
                  valueField={"code"}
                />
              </Form.Item>
            </Col> */}
          {/* <Col span={6} className="InputFieldHeight table-col">
            <Form.Item label="HAWB" className="custom-form-item">
              <ReusableInput
                name="hawb"
                value={formValues.hawb}
                onChange={handleChange}
                label={"HAWB"}
              />
            </Form.Item>
          </Col>
          <Col
            span={6}
            className={
              actionType === "view"
                ? "InputFieldHeight table-col marginTop8"
                : " InputFieldHeight table-col"
            }
          >
            <Form.Item label="MAWB" className="custom-form-item">
              <ReusableInput
                name="mawb"
                value={formValues.mawb}
                onChange={handleChange}
                label={"MAWB"}
              />
            </Form.Item>
          </Col>
          <Col
            span={6}
            className="dropdown-input-container table-col marginTop8"
          >
            <Form.Item label="Reference 1" className="custom-form-item">
              <ReusableInput
                className="refAddOn"
                prefix={addonBeforeReference1}
                name="reference_1"
                value={formValues.reference_1}
                onChange={handleChange}
                // style={{
                //   height: '32px',             // Maintain the input field height at 32px
                //   padding: '4px',             // 4px space all around
                //   boxSizing: 'border-box',    // Ensures padding doesn't affect height
                //   display: 'flex',            // Aligns items inside the input field
                //   alignItems: 'center'        // Vertically centers the dropdown
                // }}
              />
            </Form.Item>
          </Col>

          <Col
            span={6}
            className="dropdown-input-container table-col marginTop8"
          >
            <Form.Item label="Reference 2" className="custom-form-item">
              <ReusableInput
                className="refAddOn"
                prefix={addonBeforeReference2}
                name="reference_2"
                value={formValues.reference_2}
                onChange={handleChange}
                // style={{
                //   height: '32px',             // Same as above for consistency
                //   padding: '4px',             // 4px padding to create the space
                //   boxSizing: 'border-box',    // Ensures the height includes padding
                //   display: 'flex',            // Flexbox for centering
                //   alignItems: 'center'        // Vertically centers the dropdown
                // }}
              />
            </Form.Item>
          </Col>

          <Col
            className="InputFieldHeight table-col marginTop8"
            span={actionType === "view" ? 6 : 12}
          >
            <Form.Item label="Other Reference" className="custom-form-item">
              <Select
                value={
                  _.isArray(formValues.references)
                    ? _.compact(formValues.references)
                    : []
                }
                onChange={(val) => handleSelectChange(val, "references")}
                mode="tags"
                style={{ width: "100%" }}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Enter or select references"
                maxTagCount={4}
              ></Select>
            </Form.Item>
          </Col> */}
        </Row>
        {/* </div> */}
      </div>
      {showActions && (
        <div className="action_items alignRight marginTop10">
          <Button_v2
            onClick={onCancel}
            className="flat medium-btn"
            text="Cancel"
          />
          <Button_v2
            onClick={handleValidate}
            className="flat medium-btn"
            text="Save"
          />
        </div>
      )}
    </SectionCard>
  );
}, (prevProps, nextProps) => {
  // Only re-render if these props have changed
  return (
    prevProps.updatedAccountId === nextProps.updatedAccountId &&
    prevProps.details === nextProps.details &&
    prevProps.order_label_code === nextProps.order_label_code &&
    prevProps.whStorage === nextProps.whStorage &&
    prevProps.currentPreplan === nextProps.currentPreplan &&
    prevProps.configData === nextProps.configData &&
    prevProps.accounts === nextProps.accounts
  );
});

OrderdetailsComponent.propTypes = {
  currentPreplan: PropTypes.shape(),
  currentRoute: PropTypes.shape(),
  orgSettings: PropTypes.shape(),
  setOutofPreplan: PropTypes.func,
  setIsModified: PropTypes.func,
};
OrderdetailsComponent.defaultProps = {
  currentPreplan: {},
  setOutofPreplan: () => {},
  setIsModified: () => {},
  currentRoute: {},
  orgSettings: {}
};

export default OrderdetailsComponent;